import template from './adpAllErrorsList.html';
import controller from './adpAllErrorsList.controller';
import './adpAllErrorsList.less';

let adpAllErrorsListComponent = {
  restrict: 'E',
  bindings: {},
  transclude: true,
  template,
  controller
};

export default adpAllErrorsListComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpAllErrorsList/adpAllErrorsList.component.js